import { CSS } from '@grupoboticario/flora-react'

export const fullWidthCss: CSS = {
  width: '100%'
}

export const actionButtonCss: CSS = {
  minWidth: 177
}
